<template>
  <article class="slider" id="slider">
    <slick
        ref="home_slider"
        :options="slickOptions">
        <div
          class="slider__slide"
          :style="{backgroundImage: 'url(https://ippassets.s3.us-east-2.amazonaws.com/slide_1.png)'}">
          <p class="slider__slide--principal_text">
            Consultoría Especializada
          </p>
          <p class="slider__slide--secondary_text">
            Desarrollo de proyectos ambientales y de minería.
          </p>
        </div>
        <div
          class="slider__slide"
          :style="{backgroundImage: 'url(https://ippassets.s3.us-east-2.amazonaws.com/slide_2.png)'}">
          <p class="slider__slide--principal_text">
            Fluidos de Perforación y Completamiento
          </p>
          <p class="slider__slide--secondary_text">
            Productos, equipos y personal para ejecutar su proyecto.
          </p>
        </div>
        <div
          class="slider__slide"
          :style="{backgroundImage: 'url(https://ippassets.s3.us-east-2.amazonaws.com/slide_3.png)'}">
          <p class="slider__slide--principal_text">
            Control de Solidos y Tratamiento de aguas
          </p>
          <p class="slider__slide--secondary_text">
            Productos, equipos y personal para ejecutar su proyecto.
          </p>
        </div>
      </slick>
  </article>
</template>

<script>
export default {
  data(){
    return{
      slickOptions:{
        slidesToShow: 1,
        infinite: true,
        speed: 300,
        autoplay: true,
        arrows: false,
        draggable: false,
        fade: true,
        dots: true
      }
    }
  },
  methods:{
    next() {
      this.$refs.home_slider.next();
    },
    prev() {
      this.$refs.home_slider.prev();
    },
  },
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/Slider.vue